var t = /[\[\]\/\\:*?]+/;
function n(r) {
  if (!r)
    throw new Error("Sheet name can't be empty");
  if (r.length > 31)
    throw new Error('Sheet name "'.concat(r, `" can't be longer than 31 characters`));
  if (t.test(r))
    throw new Error('Sheet name "'.concat(r, '" contains illegal characters: []/\\:*?'));
}
export {
  n as default
};
//# sourceMappingURL=index.es247.js.map
